import React from 'react';
import { Button, ButtonProps, IconButton } from '@mui/material';
import { ArrowBackCircleIcon } from '../../icons';
import ButtonIcon, { ButtonIconProps } from '../ButtonIcon';
import { getPolyglot } from '../../../i18n';

export function ButtonBack(props: ButtonIconProps) {
  const polyglot = getPolyglot();
  const { children } = props;

  if (children) {
    return (
      <Button
        variant="text"
        color="inherit"
        startIcon={<ArrowBackCircleIcon height={'1.5em'} />}
        {...props}
      >
        {children}
      </Button>
    );
  }
  return (
    <IconButton
      tooltip={polyglot.t('button.back')}
      aria-label="back"
      color="inherit"
      {...props}
    >
      <ArrowBackCircleIcon height={'1em'} />
    </IconButton>
  );
}

export default ButtonBack;
